import type { TaskStatus } from '@erp/shared-types';
import { useTaskAssigneeFacets } from 'src/api/rpc/hooks/tasks/useTaskAssigneeFacets';
import {
  assigneePickerActors,
  buildAssigneeFacetInput,
  type AssigneeActor,
} from './taskQueueFilterOptions';

/** Assignee picker options from matching tasks. */
export function useQueueAssigneePicker({
  taskTypeId,
  statuses,
  outcome,
  excludeSnoozed,
  selectedAssignee,
  fallbackUsers,
  fallbackAgents,
}: {
  taskTypeId?: string;
  statuses?: TaskStatus[];
  outcome?: string;
  excludeSnoozed?: boolean;
  selectedAssignee?: string;
  fallbackUsers: AssigneeActor[] | undefined;
  fallbackAgents: AssigneeActor[] | undefined;
}) {
  const facetInput = buildAssigneeFacetInput({
    taskTypeId,
    statuses,
    outcome,
    excludeSnoozed,
  });
  const assigneeFacets = useTaskAssigneeFacets(facetInput);
  return assigneePickerActors({
    facets: assigneeFacets.isSuccess ? assigneeFacets.data : undefined,
    useFallback: assigneeFacets.isError || assigneeFacets.isAuthzError,
    fallbackUsers,
    fallbackAgents,
    selectedAssignee,
  });
}
